import { type ThemeConfig, theme as antdTheme } from 'antd'
import { brandTokens } from './brand'

export const darkTheme: ThemeConfig = {
  hashed: false,
  cssVar: {
    prefix: '',
    key: 'app',
  },
  algorithm: antdTheme.darkAlgorithm,
  token: {
    fontFamily: '"Noto Sans", sans-serif',
    fontSizeIcon: 16, // 1rem
    borderRadius: 6, // 0.375rem
    colorLink: brandTokens.tomato5,
    colorPrimary: brandTokens.tomato5,
    colorInfo: brandTokens.blue5,
    colorSuccess: brandTokens.green5,
    colorWarning: brandTokens.yellow5,
    colorError: brandTokens.red5,
    blue: brandTokens.blue7,
    cyan: brandTokens.vistaBlue3,
    geekblue: brandTokens.tekhelet5,
    green: brandTokens.green6,
    purple: brandTokens.royalPurple6,
    red: brandTokens.red5,
    yellow: brandTokens.yellow5,
    // TODO: remove after update to antd v6
    royalPurple0: '#EFE9F6',
    royalPurple1: '#E7DEF3',
    royalPurple2: '#DCCFED',
    royalPurple3: '#C7B1E3',
    royalPurple4: '#B193D8',
    royalPurple5: '#9C75CD',
    royalPurple6: '#8657C2',
    royalPurple7: '#6A3CA5',
    royalPurple8: '#502D7C',
    royalPurple9: '#351E53',
    tekhelet0: '#EEECF9',
    tekhelet1: '#CCC7E0',
    tekhelet2: '#A8A0C9',
    tekhelet3: '#8479B2',
    tekhelet4: '#7569A3',
    tekhelet5: '#655A94',
    tekhelet6: '#564A85',
    tekhelet7: '#463A76',
    tekhelet8: '#271B58',
    tekhelet9: '#090613',
  },
  components: {
    Layout: {
      headerBg: '#000000',
    },
    Rate: {
      starColor: brandTokens.yellow5, // https://github.com/ant-design/ant-design/blob/5.x-stable/components/rate/style/index.ts#L133
    },
    Menu: {
      itemBg: '#000000',
    },
  },
}
